import styles from "./styles.scss";
import {
  PopupMenu,
  RenderContentProps,
  RenderTriggerProps,
} from "@/components";
import { FC } from "react";
import { FilterTrigger } from "./trigger";
import { FilterContent } from "./content";
import { FiltersProps } from "@/pages/inbox/components/filters/types";
export const ApprovalsFilter: FC<FiltersProps> = ({
  filters,
  onSetFilters,
  onResetFilters,
  isFilterMode,
  onApplyFilters,
  disabled,
}) => {
  const handleFilterCheck = (filterName: string, value: boolean) => {
    onSetFilters(filterName, value);
  };

  const renderTrigger = ({ onClick }: RenderTriggerProps) => (
    <FilterTrigger
      onClick={onClick}
      isFilterMode={isFilterMode}
      disabled={disabled}
    />
  );

  const renderContent = ({ onClose }: RenderContentProps) => (
    <FilterContent
      filters={filters}
      onFilterCheck={handleFilterCheck}
      onClearAll={onResetFilters}
      onClose={onClose}
      onApplyFilters={onApplyFilters}
    />
  );

  return (
    <PopupMenu
      placement="bottom-end"
      renderContent={renderContent}
      renderTrigger={renderTrigger}
      className={styles.filterPopup}
    />
  );
};
